import { login, signup, verify, resendVerifyCode, createUser, updateUser, loginWithId } from "api/mutations/user"
import { getUser } from "api/queries/user"
import {
    useMutation, useQuery
} from "react-query";


export function useGetUser(params) {
    return useQuery(
        ["user", params],
        () => getUser(params),
        {
            enabled: Boolean(params?.enabled ?? true) && Boolean(params.id)
        }
    );
}

export const useCreateUser = () => {
    return useMutation((body) => createUser(body));
}

export const useUpdateUser = () => {
    return useMutation((body) => updateUser(body));
}

export function useLogin() {
    return useMutation(
        data => login(data),
    );
}

export function useSignup() {
    return useMutation(
        data => signup(data),
    );
}

export function useVerify() {
    return useMutation(
        data => verify(data),
    );
}

export function useResendVerifyCode() {
    return useMutation(
        data => resendVerifyCode(data),
    );
}

export function useLoginWithId() {
    return useMutation(
        data => loginWithId(data),
    );
}